import {
  FormField,
  SfAmountInputFormField,
  SfInputFormField,
  SfSelectFormField,
  SfUtils,
} from 'ngx-smart-form';
import { FarmingInfo } from '../farming-info-table/models/farming-info';
import { Validators } from '@angular/forms';
import { ProvinciaField } from '../../_shared/fields/provincia-field';
import { Injector } from '@angular/core';
import { FarmingTypeEnum } from '../farming-info-table/models/farming-type.enum';
import { ConduzioneStallaEnum } from '../farming-info-table/models/conduzione-stalla.enum';

export const getFarmingsDataFields = (farmings: FarmingInfo, inj: Injector) => {
  const fields: FormField[][] = [
    [
      new SfSelectFormField({
        formControlName: 'tipoAllevamento',
        label: 'Tipo Allevamento',
        required: true,
        options: Object.values(FarmingTypeEnum).map((value) => ({
          view: value,
          value,
        })),
      }),
      new SfAmountInputFormField({
        formControlName: 'numeroCapi',
        label: 'Numero Capi',
        required: true,
        decimals: 0,
        currency: '',
      }),
    ],
    [
      new SfSelectFormField({
        formControlName: 'conduzioneStalle',
        label: 'Conduzione Stalla',
        required: true,
        options: Object.values(ConduzioneStallaEnum).map((value) => ({
          view: value,
          value,
        })),
      }),
      new ProvinciaField(
        {
          formControlName: 'provincia',
          label: 'Provincia',
          required: true,
        },
        inj,
        'I'
      ),
    ],
    [
      new SfAmountInputFormField({
        formControlName: 'canoneAffitto',
        label: 'Canone Affitto',
        required: true,
        currency: '€',
        decimals: 2,
      }),
    ],
  ];

  SfUtils.assignInitialValue(fields, farmings);

  return fields;
};
